import React from "react";
import CustomNavbar from "./common/CustomNavbar";
import { getNavItems } from "./common/Sidebar";
import { useLocation } from "react-router-dom";
import { getAuthUser } from "../util/manageAuth";

export default function Navbar() {
  const { pathname } = useLocation();
  const items = getNavItems(getAuthUser()?.role);
  const current =
    items.find((item) => item.navLink === pathname) ||
    items.find((item) => pathname.startsWith(item.navLink));

  return (
    <CustomNavbar>
      <span className="truncate">{current?.name}</span>
    </CustomNavbar>
  );
}
